var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('my-breadcrumb',[_vm._v("网盘文档邮箱")]),_c('MainCard',{ref:"MainCard",attrs:{"dataResource":_vm.dataResource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }